<template>
  <section v-if="hasDesc2">
    <div class="content_bg" :style="borderStyle">
      <div class="content">
        <Caption label="설명"></Caption>
        <div class="content_core">
          <div class="desc2" v-html="formattedDesc2"></div>
        </div>
      </div>
    </div>
  </section>
  </template>
  
  <script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
  
export default {
  props: ["record", "color"],
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
  },
  computed: {
    hasDesc2() {
      return !!(this.record && this.record.desc2);
    },
    formattedDesc2() {
      return this.record && this.record.desc2
        ? this.record.desc2.replace(/\n/g, "<br>")
        : "";
    },
    borderStyle() {
      return {
        backgroundColor: this.color + "0F",
      };
    },
  },
};
  </script>
  
  <style scoped>
.content_bg {
  height: fit-content;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  position: relative;
}
  
.content {
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  display: inline-block;
  padding-top: 50px;
  padding-bottom: 50px;
}
  
.content_core {
  margin-top: 60px;
  text-align: left;
  width: 1124px;
  max-width: 1124px;
  display: inline-block;
}

.desc2 {
  font-size: 17px;
  font-weight: 400;
  color: #444444;
  line-height: 1.8;
}
  
@media screen and (max-width: 1440px) {
  .content_bg {
    height: fit-content;
  }
  
  .content {
    width: 100vw;
    height: fit-content;
    display: inline-block;
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;
  }
  
  .content_core {
    display: inline-block;
    height: fit-content;
    margin-left: 0px;
    margin-top: 0px;
    text-align: left;
    width: calc(100vw - 32px);
    max-width: 1124px;
    position: relative;
  }
}
  </style>
  
  

